import React from 'react';
import { couponDateFormat } from "../../../../common/utils/passUtil";

export default function CouponBox(props) {
  return (
    <>
      {props.data && props.data.cnt > 0 ?
        (<ul className="couponList_w">
          {
            props.data.List.map((item, index) => {
              return (
                <li className="couponList_cont">
                  <div key={`coupon-box-${index}`} className={`couponModule_typeCustomer ${props.tabType == 'expire' ? 'expireDate' : ''}`}>
                    <div className="couponModule_card">
                      <div className="couponModuleCard_Front">
                        <a href="#none" className="couponModuleCard-link">
                          <div className="couponModuleCard-Title">
                            <span className="couponModuleCard-TitleText">우수고객쿠폰</span>
                          </div>
                          <em className="couponModuleCard-BigTitle"><strong
                            className="BigTitle-type1">SBS play 이용권</strong> 90일</em>
                          <p className="couponModuleCard-info">사용기간 : {couponDateFormat(item.symd)} - {couponDateFormat(item.fymd)}</p>
                          <p className="couponModuleCard-infoText">한번 등록한 쿠폰은 취소 또는 다시 사용 할 수 없습니다.</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })
          }
        </ul>) : (<div className="noCoupon_w">
          <strong className="noCoupon_text">사용 가능한 쿠폰이 없습니다.</strong>
          <span className="iconSvg_coupon"></span>
        </div>)
      }
    </>
  );
}
